import moment from "@/utils/moment";

const lockdown_city = "Pelotas";

const lockdown_day_one = {
  name: "lockdown-thursday",
  day: "08-09",
  activePurchase: false
};

const lockdown_day_two = {
  name: "lockdown-monday",
  day: "08-10",
  activePurchase: false
};

const lockdown_day_three = {
  name: "lockdown-thursday",
  day: "08-11",
  activePurchase: false
};

const lockdown = [lockdown_day_one, lockdown_day_two, lockdown_day_three];

const dayFormat = "MM-DD";

const formatDay = day => moment(day).format(dayFormat);
const findLockdown = day => {
  day = formatDay(day);
  return lockdown.find(el => el.day === day);
};
const daysWithDisabledPurchase = address => {
  if (address.district.city.display_name === lockdown_city) {
    return lockdown.filter(el => !el.activePurchase).map(el => el.day);
  }
  return true;
};

export default {
  daysWithDisabledPurchase,
  findLockdown,
  lockdown,
  dayFormat
};



// WEBPACK FOOTER //
// ./src/utils/helpers/lockdown.js